import React from 'react';

import theOptimalState from '../theOptimalState';
import WritePage from '../../pages/WritePage';

const notes = [
  'Oblivious and happy.',
  'Oblivious and happy is the optimal state.',
  "It's the child's state.",
  'Unaware of challenges, of judgement, of pain, of failure.',
  'Happy to be alive. Playing.',
  'Unaware of their past or what the future will bring. Unaware of the long road ahead.',
  'Focused on the present because that is all that matters. And enjoying it. Being happy where you are.',
  '"Ignorance is bliss."',
  'Knowledge is power and can be used to accomplish more in the future, but too much knowledge can stop us from trying in the first place.',
  'Make room to be oblivious about how long it will take, how hard it will be. If you feel like it, do it.',
  'And make sure you choose happiness along the way.'
];

const TheOptimalState = props => <WritePage notes={notes} write={theOptimalState} {...props} />;

export default TheOptimalState;
